import React from 'react';
import { Icon } from '@iconify/react';

const ClimaTempoIcon = ({ code, alt }) => {
  
function owmToMeteocons(code) {
  const isNight = false//code.endsWith('n');
  const map = {
    '01d': 'meteocons:clear-day',
    '01n': 'meteocons:clear-night',
    '02d': 'meteocons:partly-cloudy-day',
    '02n': 'meteocons:partly-cloudy-night',
    '03d': 'meteocons:cloudy',
    '03n': 'meteocons:cloudy',
    '04d': 'meteocons:overcast',
    '04n': 'meteocons:overcast',
    '09d': 'meteocons:drizzle',
    '09n': 'meteocons:drizzle',
    '10d': 'meteocons:rain',
    '10n': 'meteocons:rain',
    '11d': 'meteocons:thunderstorms',
    '11n': 'meteocons:thunderstorms',
    '13d': 'meteocons:snow',
    '13n': 'meteocons:snow',
    '50d': 'meteocons:mist',
    '50n': 'meteocons:mist'
  };
  return map[code] || (isNight ? 'meteocons:partly-cloudy-night' : 'meteocons:partly-cloudy-day');
}

  const icon = owmToMeteocons(code);
  return (
    <Icon
      icon={icon}
      width="42"
      height="42"
      aria-label={alt}
      title={alt}
    />
  );

};

export default ClimaTempoIcon;
